import { KYMW1000Component } from './kymw1000.component';
import { LoginUserInfoModel } from './vo/login-user-info.model';

/**
 * ログイン画面の値を管理するクラス
 *
 * @export KYMW1000Model
 * @class KYMW1000Model
 */
export class KYMW1000Model {

  kYMW1000Component: KYMW1000Component;

  /** 権限リスト */
  public funcPermissionList: Array<any> = new Array<any>();

  /** お知らせ */
  public logInfo1: string = null;

  /** ユーザID */
  public userID: string = null;

  /** ユーザ名 */
  public userName: string = null;

  /** 権限ID */
  public authoritySetID: string = null;

  // 画面バインド用変数
  public user: string = null;
  public pass: string = null;

  /**
   * ユーザーIDを設定する
   * 権限セットIDを設定する
   */
  public updateUserInfo(serverData: LoginUserInfoModel): void {
    this.userID = serverData.UserID;
  }

  /**
  * ログインお知らせ内容更新
  * @param serverData:サーバから取得された情報
  */
  public updateLoginInformation(serverData: any): void {
    this.logInfo1 = serverData.Rec.Information;
  }

}
